import { AUTH_MODES } from "@l30/shared";

export const isLocalLabAuthMode = import.meta.env.VITE_AUTH_MODE === AUTH_MODES.LOCAL_LAB;
